import { render } from "./CustomerSaleInvoice.vue?vue&type=template&id=5583fb82&scoped=true"
import script from "./CustomerSaleInvoice.vue?vue&type=script&lang=js"
export * from "./CustomerSaleInvoice.vue?vue&type=script&lang=js"

import "./CustomerSaleInvoice.vue?vue&type=style&index=0&id=5583fb82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5583fb82"]])

export default __exports__